/**
 * Native (Capacitor) bootstrap. Imported once from ``index.js``. Runs
 * only when the app is loaded inside an Android or iOS shell — on a
 * plain web browser this is a no-op so bundle size on desktop stays
 * unchanged.
 *
 * Responsibilities:
 *   1. Colour the status bar with the brand accent
 *   2. Auto-hide the splash after the first paint
 *   3. Wire hardware back-button → browser history back
 *      (Android would otherwise close the app)
 */
export async function initNativeShell() {
    if (typeof window === "undefined" || !window.Capacitor) return;
    if (typeof window.Capacitor.isNativePlatform !== "function") return;
    if (!window.Capacitor.isNativePlatform()) return;

    try {
        const { StatusBar, Style } = await import("@capacitor/status-bar");
        await StatusBar.setStyle({ style: Style.Light });
        await StatusBar.setBackgroundColor({ color: "#4c1d95" });
    } catch { /* plugin unavailable */ }

    try {
        const { SplashScreen } = await import("@capacitor/splash-screen");
        // Give React a chance to render, then hide
        setTimeout(() => { SplashScreen.hide().catch(() => {}); }, 350);
    } catch { /* noop */ }

    try {
        const { App } = await import("@capacitor/app");
        App.addListener("backButton", ({ canGoBack }) => {
            if (canGoBack) window.history.back();
            else App.exitApp();
        });
    } catch { /* noop */ }
}
